// Sayaç kutusu (CourierStatsBox) için ortak kırılım tanımı. Vardiyalar sekmesi vardiya
// satırlarından, Siparişler sekmesi courierState listesinden besleniyor; iki kaynağın aynı
// kuryeyi aynı kırılımda saymasını garanti etmek için eşleme tek yerde tutuluyor.

// resolveLiveStatusLabel ile birebir aynı ham courierState.status ->
// kırılım eşlemesi. Vardiya etiketleri de aynı kaynaktan üretildiği için iki fonksiyon senkron
// kalır.
export const bucketFromCourierStatus = status => {
    if (["ready", "available"].includes(status)) return "available";
    if (["busy", "assigned", "waitingForCourier"].includes(status)) return "onDelivery";
    if (status === "onBreak") return "onBreak";
    return "unavailable"; // unavailable ve tanımsız durumlar
};

//  SHIFT_STATUS_FILTERS ile birebir aynı etiketler. Diğer durumlar
// (Beklemede, Henüz Giriş Yapılmadı, Tamamlandı, Giriş Yapılmadan Tamamlandı) kutuya girmez.
const SHIFT_STATUS_TO_BUCKET = {
    "Vardiyada - Müsait": "available",
    "Vardiyada - Meşgul": "unavailable",
    "Vardiyada - Siparişte": "onDelivery",
    "Vardiyada - Mola": "onBreak"
};

export const bucketFromShiftStatus = status => SHIFT_STATUS_TO_BUCKET[status] || null;

const emptyStats = () => ({total: 0, available: 0, unavailable: 0, onDelivery: 0, onBreak: 0});

/** Vardiya satırlarından (courierId + status) sayaç kutusu için kırılımları üretir. Aynı kurye
 * hem dedike hem havuz vardiyasında olabildiğinden benzersiz courierId üzerinden sayılır. */
export const buildCourierStatsFromShiftRows = (rows = []) => {
    const bucketSets = {
        available: new Set(),
        unavailable: new Set(),
        onDelivery: new Set(),
        onBreak: new Set()
    };

    rows.forEach(row => {
        const courierId = row.courierId && String(row.courierId);
        if (!courierId) return;
        const bucket = bucketFromShiftStatus(row.status);
        if (bucket) bucketSets[bucket].add(courierId);
    });

    const total = new Set([
        ...bucketSets.available,
        ...bucketSets.unavailable,
        ...bucketSets.onDelivery,
        ...bucketSets.onBreak
    ]).size;

    return {
        total,
        available: bucketSets.available.size,
        unavailable: bucketSets.unavailable.size,
        onDelivery: bucketSets.onDelivery.size,
        onBreak: bucketSets.onBreak.size
    };
};

/** courier/maplist'ten gelen courierStateList için sayaç kutusu kırılımlarını üretir. Liste
 * zaten kurye başına tekil olduğundan total, liste uzunluğudur. */
export const buildCourierStatsFromCourierStates = (courierStateList = []) => {
    const stats = emptyStats();
    stats.total = courierStateList.length;
    courierStateList.forEach(courierState => {
        const bucket = bucketFromCourierStatus(courierState.status);
        stats[bucket] += 1;
    });
    return stats;
};
